import React from 'react'
import { useTheme } from 'styled-components'
import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import { MaterialIcon, Tonality } from '@dsny/dsny-component-library'
import { useMobileMediaQuery } from 'utils/hooks/useMediaQueries'
import { useTranslation } from 'react-i18next'
import styles from '../Dropdowns.module.scss'
import { MetaFormat } from 'constants/enums'
import { ReleasesService } from 'services'
import Tooltip from 'components/Tooltip'

const DownloadMetaData = ({ release }) => {
  const theme = useTheme()
  const isMobile = useMobileMediaQuery()
  const { t } = useTranslation()
  const handleDownloadMeta = async (e, releaseid, format) => {
    e.stopPropagation()
    const metaLink = await ReleasesService.getPdfLink(releaseid, format)
    window.open(metaLink)
  }

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger
        asChild
        onClick={(e) => e.stopPropagation()}>
        <button
          type="button"
          style={{
            alignItems: 'center',
            background: 'none',
            border: 'none',
            display: 'inline-flex',
            margin: 0,
            padding: 0
          }}>
          <Tooltip
            hasArrow={false}
            placement="top"
            text={t('release-info.download-all-metadata')}
            wrapperStyles={{ width: isMobile ? '100%' : 'auto' }}>
            <Tonality.Pill
              variant="outlined"
              mode="dark"
              label={t('release-info.metadata')}
              icon={
                <MaterialIcon
                  name="FileDownload"
                  color={theme.colors.neutralW90} />
              } />
          </Tooltip>
        </button>
      </DropdownMenu.Trigger>

      <DropdownMenu.Portal>
        <DropdownMenu.Content
          side="bottom"
          align="end"
          style={{
            background: theme.colors.neutralW20,
            color: theme.colors.neutralW100
          }}
          className={styles.DropdownMenuContent}
          sideOffset={5}
        >
          <DropdownMenu.Item
            className={styles.DropdownMenuItem}
            onClick={(e) =>
              handleDownloadMeta(e, release.releaseid, MetaFormat.pdf?.value)
            }
          >
            {t('release-info.download-all-pdf')}
          </DropdownMenu.Item>

          <DropdownMenu.Item
            className={styles.DropdownMenuItem}
            onClick={(e) =>
              handleDownloadMeta(e, release.releaseid, MetaFormat.csv?.value)
            }
          >
            {t('release-info.download-all-csv')}
          </DropdownMenu.Item>
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  )
}

export default DownloadMetaData
